import React from 'react';
type CommonProps = {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
};
type ButtonAsButton = CommonProps & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, keyof CommonProps> & {
  href?: undefined;
};
type ButtonAsLink = CommonProps & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof CommonProps> & {
  href: string;
};
type ButtonProps = ButtonAsButton | ButtonAsLink;
const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 ease-out rounded-full tracking-wide';
const variants = {
  primary: 'bg-gold text-gold-foreground hover:bg-gold-light shadow-gold hover:shadow-lg hover:-translate-y-0.5',
  secondary: 'bg-foreground text-surface hover:bg-muted-foreground',
  outline: 'border border-gold text-gold hover:bg-gold hover:text-gold-foreground',
  ghost: 'text-foreground hover:text-gold hover:bg-surface'
};
const sizes = {
  sm: 'px-6 py-2.5 text-sm',
  md: 'px-8 py-3.5 text-base',
  lg: 'px-10 py-4 text-lg'
};
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (typeof props.href === 'string') {
    const {
      href,
      ...anchorProps
    } = props as ButtonAsLink;
    return <a href={href} className={classes} {...anchorProps} data-id="element-266">
        {children}
      </a>;
  }
  const buttonProps = props as React.ButtonHTMLAttributes<HTMLButtonElement>;
  return <button className={classes} {...buttonProps} data-id="element-267">
      {children}
    </button>;
}